import { render, staticRenderFns } from "./DataWriteBD.vue?vue&type=template&id=edc25a44&scoped=true"
import script from "./DataWriteBD.vue?vue&type=script&lang=js"
export * from "./DataWriteBD.vue?vue&type=script&lang=js"
import style0 from "./DataWriteBD.vue?vue&type=style&index=0&id=edc25a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc25a44",
  null
  
)

export default component.exports